/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DowntimeSection } from '../../models/downtime-section';

export interface GetReasonsTreeList$Params {
  workCenterId: number;
}

export function getReasonsTreeList(http: HttpClient, rootUrl: string, params: GetReasonsTreeList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DowntimeSection>>> {
  const rb = new RequestBuilder(rootUrl, getReasonsTreeList.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DowntimeSection>>;
    })
  );
}

getReasonsTreeList.PATH = '/api/v1/Downtimes/ReasonsTreeList/{workCenterId}';
